import { buttonClick, pageview } from '@wix/bi-logger-vmaf/v2';
import { connect } from 'react-redux';
import { IRootState } from '../../redux/rootReducer';
import * as selectors from '../../redux/videoInfo/selectors';
import { VideoType } from '../../redux/videoInfo/types';
import biLogger from './biLogger';

interface IPageBI {
  pageview(): void;
  buttonClick(buttonName: string, data?: Record<string, any>): void;
}

interface IWithPageBIProps {
  pageBI: IPageBI;
}

class PageBI implements IPageBI {
  pageName: string;
  videoType?: VideoType;

  constructor(pageName: string, videoType?: VideoType) {
    this.pageName = pageName;
    this.videoType = videoType;
  }

  buttonClick(buttonName: string, data?: Record<string, any>) {
    void biLogger.report(
      buttonClick({
        type: this.videoType,
        pageName: this.pageName,
        buttonName,
        jsonData: data && JSON.stringify(data),
      }),
    );
  }

  pageview() {
    void biLogger.report(
      pageview({ type: this.videoType, pageName: this.pageName }),
    );
  }
}

function withPageBI(pageName: string) {
  return connect((state: IRootState) => ({
    pageBI: new PageBI(pageName, selectors.getVideoType(state)),
  }));
}

export { IWithPageBIProps, IPageBI };

export default withPageBI;
